import { useEffect, useState } from 'react'

// Pagina ponte (ADR 0019, Fase 2): arrivando da un link inviato dal bot su WhatsApp
// (…/chat?t=<token>), legge il token, lo passa al broker n8n che restituisce
// identifier + identifier_hash, e chiama window.$chatwoot.setUser per far riconoscere
// al widget lo STESSO contatto (per codice cliente). Senza token (o token scaduto) si
// apre comunque la chat come visitatore anonimo. La nuvoletta è montata sitewide (root).
const BROKER = 'https://n8n.spadhausen.com/webhook/chat-identity'

type Chatwoot = {
  setUser: (identifier: string, opts: { identifier_hash: string; name?: string }) => void
  toggle: (state?: 'open' | 'close') => void
}
function chatwoot(): Chatwoot | undefined {
  return (window as unknown as { $chatwoot?: Chatwoot }).$chatwoot
}

export function Chat() {
  const [message, setMessage] = useState('Apriamo la chat…')

  useEffect(() => {
    let cancelled = false
    const token = new URLSearchParams(window.location.search).get('t')

    async function identifyAndOpen() {
      let name = ''
      if (token) {
        try {
          const res = await fetch(`${BROKER}?t=${encodeURIComponent(token)}`)
          const data = await res.json()
          if (!cancelled && data && data.ok) {
            chatwoot()?.setUser(String(data.identifier), {
              identifier_hash: String(data.identifier_hash),
              name: data.name || undefined,
            })
            name = data.name || ''
          }
        } catch {
          // token non valido/scaduto: si prosegue come visitatore anonimo
        }
      }
      if (cancelled) return
      chatwoot()?.toggle('open')
      setMessage(
        name
          ? `Bentornato/a ${name}! Riprendiamo qui sotto.`
          : 'Chat aperta: scrivici pure qui sotto, ti rispondiamo subito.'
      )
    }

    if (chatwoot()) {
      identifyAndOpen()
    } else {
      const onReady = () => identifyAndOpen()
      window.addEventListener('chatwoot:ready', onReady, { once: true })
      return () => {
        cancelled = true
        window.removeEventListener('chatwoot:ready', onReady)
      }
    }
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <main style={{ minHeight: '60vh', display: 'grid', placeItems: 'center', padding: '4rem 1.5rem', textAlign: 'center' }}>
      <div>
        <h1 style={{ margin: '0 0 0.5rem' }}>Assistenza Spadhausen</h1>
        <p style={{ opacity: 0.8 }}>{message}</p>
      </div>
    </main>
  )
}
